<template lang="pug">
	.display-object-tree-line(v-on:mousedown="startDisplayObjectsDragDetection(displayObject, $event)")
		.eye.fa(:class=`{
				'fa-eye-slash': displayObject.options.dashboardVisibility === false,
				'fa-eye': displayObject.options.dashboardVisibility !== false
			}` v-on:click="toggleDashboardVisibility(displayObject)")
		.margin(:style="{width: `${displayObject._offset * 10}px`}")
		.toggle.fa(:class=`{
				'fa-angle-right': displayObject.childs && displayObject.options.dashboardExpanded === false,
				'fa-angle-down': displayObject.childs && displayObject.options.dashboardExpanded !== false
			}` v-on:click="toggleExpanded(displayObject)")
		.icon.fa(:class=`{
				'fa-folder': displayObject.type === 'container',
				'fa-picture-o': displayObject.type === 'sprite',
				'fa-font': displayObject.type === 'text',
				'fa-pencil': displayObject.type === 'graphics'
			}` v-on:click="selectDisplayObject(displayObject.codename)")
		.name
			input.dynamic-name(ref="codename-input" v-if="renameMode" :value="displayObject._tmpCodename || displayObject.codename" :style="{'width': `calc(330px - 35px - ${displayObject._offset * 10}px)`}" v-on:change="renameDisplayObject($event.target.value)" v-on:blur="renameMode = false" v-on:keyup="processRenameKeyUp($event)")
			.static-name(v-else :style="{'width': `calc(330px - 35px - ${displayObject._offset * 10}px)`}" v-on:click="processDisplayObjectCodenameClick()") {{displayObject._tmpCodename || displayObject.codename}}
</template>

<script>

	import Screen 					from './../../mixins/screen'

	import SettingControls 			from './SettingControls.vue'

	import { DisplayObject }		from './../../services/DisplayObject'

	export default {
		name: 'DisplayObjectsTreeLine',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Settings Tab Changed:display-objects"
			],
			events: {
				"Display Object Hierarchy Changed,Selected Version Display Object Deleted,Selected Version Display Object Added": function(displayObject) {

					if (this.displayObject['version_id'] === displayObject['version_id'] && this.displayObject['screen_codename'] === displayObject['screen_codename'] && this.displayObject['codename'] === displayObject['codename']) this.update();
					if (this.displayObject['version_id'] === displayObject['version_id'] && this.displayObject['screen_codename'] === displayObject['screen_codename'] && this.displayObject['codename'] === displayObject['parent']) this.update();

				}
			}
		},
		components: {
			SettingControls
		},
		props: ['displayObject', 'toggleDashboardVisibility', 'toggleDashboardExpanded', 'selectDisplayObject', 'startDisplayObjectsDragging'],
		data() {

			return {
				showed: true,
				dragDetection: null,
				doubleClickDetection: null,
				renameMode: false
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragDetection) this.stopDisplayObjectsDragDetection();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragDetection) this.processDisplayObjectsDragDetection(e);

			});

		},
		methods: {
			collectData() {

			},
			toggleExpanded(displayObject) {

				this.toggleDashboardExpanded(displayObject);

				this.update();

			},
			startDisplayObjectsDragDetection(displayObject, e) {

				this.dragDetection = {
					dragStartMousePosition: e.clientY
				}

			},
			processDisplayObjectsDragDetection(e) {

				if (Math.abs(e.clientY - this.dragDetection.dragStartMousePosition) > 10) {

					this.startDisplayObjectsDragging(this.displayObject, this.dragDetection.dragStartMousePosition, e);

					this.dragDetection = null;

				}

			},
			stopDisplayObjectsDragDetection() {

				this.dragDetection = null;

			},
			processDisplayObjectCodenameClick() {

				if (!this.doubleClickDetection) {

					this.doubleClickDetection = {
						isDisplayObjectSelected: DisplayObject.SelectedDisplayObject?.codename === this.displayObject.codename,
						timeout: setTimeout(() => {

							if (this.doubleClickDetection) {

								//Здесь мы уже понимаем что клик одинарный - нужно сделать переключение выделения учитывая то каким оно было в начале двойного клика
								if (this.doubleClickDetection.isDisplayObjectSelected) this.selectDisplayObject(this.displayObject.codename, true, true);

								this.doubleClickDetection = null;

							}

						}, 200)
					};

					//При первом клике не важно единственный он будет или двойной - нужно выделить этот объект, если он не был выделен
					if (DisplayObject.SelectedDisplayObject?.codename !== this.displayObject.codename) this.selectDisplayObject(this.displayObject.codename, true, false);

				} else {

					//При двойном клике - нужно выделить этот объект, если он не был выделен
					if (DisplayObject.SelectedDisplayObject?.codename !== this.displayObject.codename) this.selectDisplayObject(this.displayObject.codename, true, false);

					clearTimeout(this.doubleClickDetection.timeout);

					this.doubleClickDetection = null;

					this.renameMode = true;

					this.$nextTick(() => {

						this.$refs['codename-input'].focus();

					});

				}

			},
			processRenameKeyUp(e) {

				if (e.keyCode === 13) {

					this.renameMode = false;

				}

			},
			renameDisplayObject(newDisplayObjectCodename) {

				Server.sendToServer({
					RenameDisplayObject: {
						versionId: Version.SelectedVersion.id,
						screenCodename: this.displayObject['screen_codename'],
						displayObjectCodename: this.displayObject['codename'],
						newDisplayObjectCodename: newDisplayObjectCodename
					}
				});

				this.displayObject._tmpCodename = newDisplayObjectCodename;

			}

		}

	}
</script>

<style lang="sass">

	.tree, .drag-tree

		.tree-line

			.display-object-tree-line
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: left
				align-items: center
				height: 31px
				padding-left: 0
				border-top: 1px solid #343a42
				border-bottom: 1px solid #343a42
				margin-top: -1px

			&.selected .display-object-tree-line
				background-color: rgba(255, 255, 255, 0.1)

			&.dragged .display-object-tree-line
				visibility: hidden

			&.dragged.cloning .display-object-tree-line
				visibility: visible

			&.put-in .display-object-tree-line
				background-color: rgba(0, 0, 0, 0.3)

			&.dragged-over .display-object-tree-line
				background-color: rgba(255, 255, 255, 0.05)

			.eye
				display: flex
				justify-content: center
				align-items: center
				width: 30px
				height: 20px
				font-size: 11px
				padding: 0 5px
				border-right: 1px solid rgba(0, 0, 0, 0.1)

			&.hidden .eye
				opacity: 0.3

			.eye:hover
				color: #20a8d8
				opacity: 1

			&.selected .eye,
			&.hit .eye
				border-right: 1px solid rgba(255, 255, 255, 0.1)

			.toggle
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				font-size: 12px
				padding: 0

			&.hidden .toggle
				opacity: 0.3

			.icon
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				font-size: 11px
				padding-top: 2px
				opacity: 0.2

			&.selected .icon
				opacity: 0.5

			.name
				display: flex
				justify-content: left
				align-items: center
				height: calc(100% - 2px)
				padding-left: 3px

				.dynamic-name
					outline: none
					color: #fff
					border: none
					border-bottom: 1px solid rgba(255, 255, 255, 0.2)
					background-color: transparent

			&.hidden .name
				opacity: 0.3

		.tree-line

			.eye, .toggle, .icon, .name
				cursor: pointer

	.tree.sorting, .drag-tree.sorting
		cursor: grabbing

		.tree-line

			.eye, .toggle, .icon, .name
				cursor: grabbing

	.tree.sorting.cloning, .drag-tree.sorting.cloning
		cursor: copy

		.tree-line

			.eye, .toggle, .icon, .name
				cursor: copy

</style>
